/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Форма отзыва в карточке товара
   */
  app.ItemComment = app.Model.extend({
    urlRoot: app.entryScriptName + '/api/v3/item-comment',
    defaults: {
      'is_anonymously': false,
      'reactions': []
    },
    expand: 'expand=user,reactions,item_comment_photos'
  });
})();

}.call(window));